<template>
  <Section :settings="sectionSettings">
    <div class="hero-section" :class="alignmentClass">
      <div class="d-flex">
        <div class="content d-flex flex-column justify-content-around">
          <div class="logo" v-if="content.company_logo?.blob_url">
            <img :src="content.company_logo?.blob_url" alt="" />
          </div>
          <div class="text">
            <h1>{{ settings.title }}</h1>
            <p class="description">{{ settings.description }}</p>
          </div>
          <div v-if="settings.show_cta">
            <CtaButton :settings="settings" />
          </div>
        </div>
        <div class="image" v-if="showImage">
          <img :src="image" alt="" />
        </div>
      </div>
    </div>
  </Section>
</template>
<script lang="ts" setup>
import { defineProps, computed } from 'vue'
import { HeroContent, SectionSettings } from './types'
import Section from './Section.vue'
import CtaButton from './CtaButton.vue'

interface Props {
  content: HeroContent
  settings?: SectionSettings
}

const props = withDefaults(defineProps<Props>(), {
  settings: () =>
    ({
      title: 'Hero Section',
      show_title: true,
      alignment: 'left',
      cta: 'Learn more',
      cta_url: '#',
      show_cta: true,
      description: 'Hero Section Description',
      show_description: true,
      design_settings: {
        colors: [],
        fonts: [],
      },
    }) as SectionSettings,
  content: () => ({
    company_logo: null,
    image: null,
  }),
})

const sectionSettings = computed(() => {
  return {
    ...props.settings,
    show_title: false,
  }
})

const image = computed(() => props.content.image?.blob_url || 'default-image.jpg')

const showImage = computed(() => {
  return alignmentClass.value === 'left-aligned'
})

const alignmentClass = computed(() => {
  if (props.settings.alignment === 'left') return 'left-aligned'
  if (props.settings.alignment === 'center') return 'center-aligned'
  else return 'left-aligned'
})
</script>
<style scoped lang="sass">
.hero-section
  .d-flex
    min-height: 370px
  &.left-aligned
    .content
      width: 60%
      padding-right: 20px
      .logo
        width: 20%
        img
          width: 100%
          height: auto
    .image
      width: 40%
      text-align: right
      display: flex
      align-items: center
      img
        width: 100%
        height: auto
  &.center-aligned
    .d-flex
      height: 100%
    .content
      min-height: 400px
      width: 100%
      text-align: center
      align-items: center
      .logo
        width: 20%
        img
          width: 100%
          height: auto
    .image
      display: none
</style>
